import React from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import renderField from '../../../shared/components/form/RenderField';
import Select from '../../../shared/components/form/Select';
import { onlyNumbersFormatString } from '../../../shared/components/form/Masks';
import CourseStep from './CourseStep';

const CourseTab = ({ t, dto, employees, removeCourseStep }) => {
  return (
    <div className="form">
      <div className="form__form-group">
        <span className="form__form-group-label">{t('general.name')}</span>
        <div className="form_form-group-field">
          <Field
            name="name"
            type="text"
            component={renderField}
            maxLength="50"
            placeholder={t('placeholder.course.name')}
          />
        </div>
      </div>
      <div className="form__form-group--2_columns">
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.coordination')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="coordinator"
              component={Select}
              options={employees}
              placeholder={t('placeholder.course.select')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.direction')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="director"
              component={Select}
              options={employees}
              placeholder={t('placeholder.course.select')}
            />
          </div>
        </div>
      </div>
      <div className="form__form-group--4_columns">
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.percentage-frequency-required')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="minFrequency"
              type="text"
              component={renderField}
              parse={(value) => onlyNumbersFormatString(value, '99,99')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.average-approval')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="mediaApproval"
              type="text"
              component={renderField}
              placeholder={t('placeholder.course.enter-average')}
              parse={(value) => onlyNumbersFormatString(value, '999,99')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.course-duration-days')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="durationInDays"
              component={renderField}
              placeholder={t('placeholder.course.enter-days')}
              parse={(value) => onlyNumbersFormatString(value, '9999')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.total-workload')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="workload"
              component={renderField}
              parse={(value) => onlyNumbersFormatString(value, '9999,99')}
              placeholder={t('placeholder.course.enter-workload')}
            />
          </div>
        </div>
      </div>
      <div className="form__form-group--2_columns">
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.enter-score-min')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="minNote"
              component={renderField}
              placeholder={t('placeholder.course.enter-score')}
              parse={(value) => onlyNumbersFormatString(value, '9999,99')}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.enter-score-max')}
          </span>
          <div className="form_form-group-field">
            <Field
              name="maxNote"
              component={renderField}
              placeholder={t('placeholder.course.enter-score')}
              parse={(value) => onlyNumbersFormatString(value, '9999,99')}
            />
          </div>
        </div>
      </div>
      <div className="form__form-group">
        <span className="form__form-group-label">
          {t('general.enter-years-and-grades-course')}
        </span>
        <div className="form_form-group-field">
          <Field name="steps">
            {(propsx) => (
              <CourseStep
                {...propsx}
                data={dto.steps}
                removeCourseStep={removeCourseStep}
              />
            )}
          </Field>
        </div>
      </div>
    </div>
  );
};

CourseTab.propTypes = {
  t: PropTypes.func.isRequired,
  dto: PropTypes.shape(PropTypes.shape).isRequired,
  employees: PropTypes.arrayOf(PropTypes.shape(PropTypes.shape)).isRequired,
  removeCourseStep: PropTypes.func.isRequired,
};

export default withTranslation('common')(CourseTab);
